import React from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import { bindActionCreators } from 'redux'
import { SubmissionError } from 'redux-form'

import { addUniversalFilteringUpdateApp } from '../actions/universalupdates'
import { fetchMachines } from '../actions/machines'
import { renderInputField } from '../utils/forms'

class UniversalUpdateFilteringAppAddForm extends React.Component {
  constructor(props) {
    super(props)
    this.submit = this.submit.bind(this)
  }

  componentDidMount() {
    this.props.fetchMachines()
  }

  submit(values) {
    const { arguments: url, ...rest } = values

    // Extract selected machine IDs from the form
    const selectedMachineIds = Object.entries(rest)
      .filter(([key, value]) => key.startsWith('machine_') && value)
      .map(([key]) => key.replace('machine_', ''))

    return this.props.addUniversalFilteringUpdateApp({ url, machines: selectedMachineIds })
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        return response
      })
  }

  renderMachineCheckbox(machine) {
    return (
      <div key={machine._id} className="form-check mb-2">
        <Field
          name={`machine_${machine._id}`}
          id={`machine_${machine._id}`}
          component="input"
          type="checkbox"
          className="form-check-input"
        />
        <label htmlFor={`machine_${machine._id}`} className="form-check-label">
          <div>
            <strong>{machine.Serial} / </strong>
            <span>V{machine.Sw_version} / </span>
            <span>
              {machine.OS === 2 ? (
                <>
                  <i className="fa-brands fa-ubuntu mr-1"></i> <span>Ubuntu</span>
                </>
              ) : (
                <>
                  <i className="fa-brands fa-raspberry-pi mr-1"></i> <span>Raspbian</span>
                </>
              )}
            </span>
          </div>
        </label>
      </div>
    )
  }

  renderSummary() {
    const { selectedMachinesMap, machines } = this.props

    const selectedMachines = machines.filter(
      m => selectedMachinesMap && selectedMachinesMap[`machine_${m._id}`]
    )

    if (selectedMachines.length === 0) return null

    return (
      <div className="alert alert-info mt-4">
        <h6>Resumen de máquinas seleccionadas ({selectedMachines.length})</h6>
        <br></br>
        <ul className="mb-0">
          {selectedMachines.map(machine => (
            <li key={machine._id}>
              <strong>{machine.Serial}</strong> – V{machine.Sw_version} –{' '}
              {machine.OS === 2 ? 'Ubuntu' : 'Raspbian'}
            </li>
          ))}
        </ul>
      </div>
    )
  }

  render() {
    const { error, pristine, submitting, handleSubmit, machines } = this.props

    // Group machines by customer
    const machinesByCustomer = machines.reduce((acc, machine) => {
      const customer = machine.Customer?.Fullname || 'Sin Cliente'
      acc[customer] = acc[customer] || []
      acc[customer].push(machine)
      return acc
    }, {})

    return (
      <div>
        <form onSubmit={handleSubmit(this.submit)} className="mb-3">
          <div className="form-row">
            <div className="col-md-12">
              <Field name="arguments"
                type="text"
                component={renderInputField}
                label="App URL" />
            </div>
          </div>

          {Object.keys(machinesByCustomer).length === 0 && (
            <p className="text-muted mt-3">Cargando máquinas o ninguna disponible...</p>
          )}

          <div className='row'>
            {Object.entries(machinesByCustomer).map(([customer, machines]) => (
              <div key={customer} className="col-xs-12 col-md-4 col-lg-3">
                <div className="m-3 border p-3 rounded">
                  <h5 className='text-center'>{customer}</h5>
                  {machines.map(machine => this.renderMachineCheckbox(machine))}
                </div>
              </div>
            ))}
          </div>

          {this.renderSummary()}

          <div className="form-row mt-3">
            <div className="col-md-12 text-center">
              <button className="btn bg-vw-light text-white mr-1" type="submit"
                disabled={pristine || submitting}>
                <i className="fas fa-bolt mr-1"></i>Ejecutar
              </button>
            </div>
          </div>

          {error && (
            <div className="form-row">
              <div className="alert alert-danger col-md-12">{error}</div>
            </div>
          )}
        </form>
      </div>
    )
  }
}

// Redux Form wrapper
UniversalUpdateFilteringAppAddForm = reduxForm({
  form: 'UniversalUpdateFilteringAppAddForm',
})(UniversalUpdateFilteringAppAddForm)

// Map state from Redux
const selector = formValueSelector('UniversalUpdateFilteringAppAddForm')

const mapStateToProps = (state) => {
  const machines = state.machines.machines || []

  const machineFieldNames = machines.map(m => `machine_${m._id}`)
  const selectedMachinesMap = machineFieldNames.length
    ? selector(state, ...machineFieldNames)
    : {}

  return {
    machines,
    selectedMachinesMap,
  }
}

// Map dispatch actions
const mapDispatchToProps = (dispatch) => ({
  addUniversalFilteringUpdateApp: bindActionCreators(addUniversalFilteringUpdateApp, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
})

// Connect Redux and export
export default connect(mapStateToProps, mapDispatchToProps)(UniversalUpdateFilteringAppAddForm)
